{
  "UI Elements": "ÉLÉMENTS DE L'UI",
  "Forms & Tables": "Formulaires et tableaux",
  "Pages": "Des pages",
  "Charts & Maps": "Graphiques et cartes",
  "Others": "Autres",
  "Typography": "Typographie",
  "Cards": "Cartes",
  "Basic": "De base",
  "Advance": "Avance",
  "Widgets": "Widget",
  "Card Action": "Action de la carte",
  "Components": "Composants",
  "Alert": "Alerte",
  "Close Alert": "Fermer l'alerte",
  "Avatar": "Avatar",
  "Badge": "Badge",
  "Button": "Bouton",
  "Calendar": "Calendrier",
  "Image": "Image",
  "Pagination": "Pagination",
  "Progress Circular": "Progrès circulaire",
  "Progress Linear": "Progrès Linéaire",
  "Autocomplete": "Saisie automatique",
  "Tooltip": "Info-bulle",
  "Slider": "Glissière",
  "Date Time Picker": "Sélecteur de date et d'heure",
  "Select": "Sélectionner",
  "Switch": "Commutateur",
  "Checkbox": "Case à cocher",
  "Radio": "Radio",
  "Textarea": "Textarea",
  "Rating": "Évaluation",
  "File Input": "Entrée de fichier",
  "Otp Input": "Entrée Otp",
  "Form Layout": "Disposition du formulaire",
  "Form Validation": "Validation de formulaire",
  "Charts": "Graphiques",
  "Apex Chart": "Graphique Apex",
  "Chartjs": "Chartjs",
  "Account Settings": "Paramètres du compte",
  "User Profile": "Profil de l'utilisateur",
  "FAQ": "FAQ",
  "Dialog Examples": "Exemples de dialogue",
  "Pricing": "Tarification",
  "List": "liste",
  "Edit": "Éditer",
  "Nav Levels": "Niveaux de navigation",
  "Level 2.1": "Niveau 2.1",
  "Level 2.2": "Niveau 2.2",
  "Level 3.1": "Niveau 3.1",
  "Level 3.2": "Niveau 3.2",
  "Raise Support": "Augmenter le soutien",
  "Documentation": "Documentation",
  "Dashboards": "Tableaux de bord",
  "Analytics": "Analytique",
  "Apps & Pages": "Applications et pages",
  "Email": "Email",
  "Chat": "Bavarder",
  "Invoice": "Facture d'achat",
  "Preview": "Aperçu",
  "Add": "Ajouter",
  "User": "Utilisateur",
  "View": "Vue",
  "Login v1": "Connexion v1",
  "Login v2": "Connexion v2",
  "Login": "Connexion",
  "Register v1": "S'inscrire v1",
  "Register v2": "S'inscrire v2",
  "Register": "S'inscrire",
  "Forget Password v1": "Oubliez le mot de passe v1",
  "Forget Password v2": "Oubliez le mot de passe v2",
  "Forgot Password v1": "Oubliez le mot de passe v1",
  "Forgot Password v2": "Oubliez le mot de passe v2",
  "Forgot Password": "Oubliez le mot de passe",
  "Reset Password v1": "Réinitialiser le mot de passe v1",
  "Reset Password v2": "Réinitialiser le mot de passe v2",
  "Reset Password": "Réinitialiser le mot de passe",
  "Miscellaneous": "Divers",
  "Coming Soon": "Bientôt disponible",
  "Not Authorized": "Pas autorisé",
  "Under Maintenance": "En maintenance",
  "Error": "Erreur",
  "Statistics": "Statistiques",
  "Card Actions": "Actions de la carte",
  "Actions": "Actions",
  "Access Control": "Contrôle d'accès",
  "User Interface": "Interface utilisateur",
  "CRM": "CRM",
  "eCommerce": "commerce électronique",
  "Icons": "Icône",
  "Chip": "Ébrécher",
  "Dialog": "Dialogue",
  "Expansion Panel": "Panneau d'extension",
  "Combobox": "Boîte combo",
  "Textfield": "Champ de texte",
  "Range Slider": "Curseur Gamme",
  "Menu": "Menu",
  "Snackbar": "Casse-croûte",
  "Tabs": "Onglets",
  "Form Elements": "Éléments de formulaire",
  "Form Layouts": "Dispositions de formulaire",
  "Authentication": "Authentification",
  "Page Not Found - 404": "Page introuvable - 404",
  "Not Authorized - 401": "Non autorisé - 401",
  "Server Error - 500": "Erreur de serveur - 500",
  "2": "2",
  "Forms": "Formes",
  "Timeline": "Chronologie",
  "Disabled Menu": "Menu désactivé",
  "Help Center": "Centre d'aide",
  "Verify Email": "Vérifier les courriels",
  "Verify Email v1": "Vérifier l'e-mail v1",
  "Verify Email v2": "Vérifier l'e-mail v2",
  "Two Steps": "Deux étapes",
  "Two Steps v1": "Deux étapes v1",
  "Two Steps v2": "Deux étapes v2",
  "Custom Input": "Entrée personnalisée",
  "Extensions": "Rallonges",
  "Tour": "Tour",
  "Register Multi-Steps": "Enregistrer plusieurs étapes",
  "Wizard Examples": "Exemples de guide",
  "Checkout": "Check-out",
  "Create Deal": "Créer une offre",
  "Property Listing": "Liste des propriétés",
  "Roles & Permissions": "Rôles et autorisations",
  "Roles": "Rôles",
  "Permissions": "Autorisations",
  "Simple Table": "Table simple",
  "Tables": "Tables",
  "Data Table": "Table de données",
  "Apps": "Applications",
  "Misc": "Divers",
  "Wizard Pages": "Pages de l'assistant",
  "Form Wizard": "Assistant de formulaire",
  "Numbered": "Numéroté",
  "3": "3",
  "ecommerce": "commerce électronique",
  "Ecommerce": "Commerce électronique",
  "Product": "Produit",
  "Category": "Catégorie",
  "Order": "Ordre",
  "Details": "Détails",
  "Customer": "Client",
  "Manage Review": "Gérer la revue",
  "Referrals": "Références",
  "Settings": "Paramètres",
  "Course Details": "Détails du cours",
  "My Course": "Mon cours",
  "Overview": "Aperçu",
  "Academy": "Académie",
  "Logistics": "Logistique",
  "Dashboard": "Tableau de bord",
  "Fleet": "Flotte",
  "Editors": "Éditeurs",
  "Front Pages": "Pages frontales",
  "Landing": "d'atterrissage",
  "checkout": "Check-out",
  "Payment": "Paiement",
  "Swiper": "Swiper",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "login": {
    "errors": {
      "signInFailed": "Échec de la connexion. Veuillez réessayer.",
      "noAccess": "Ce compte n'a pas accès au back-office.",
      "invalidCredentials": "E-mail ou mot de passe incorrect.",
      "missingCredentials": "Saisissez un e-mail et un mot de passe."
    },
    "googleCta": "Se connecter avec Google",
    "orDivider": "ou",
    "emailLabel": "E-mail",
    "passwordLabel": "Mot de passe",
    "loginCta": "Se connecter"
  },
  "orders": {
    "filters": {
      "title": "Planification"
    },
    "plan": {
      "title": "Planification",
      "destinationLabel": "Destination de conduite",
      "dateLabel": "Date prévue",
      "applyCta": "Planifier",
      "resetCta": "Réinitialiser",
      "exportCta": "Exporter CSV",
      "selectDate": "Choisissez une date pour charger le plan",
      "loading": "Chargement…",
      "empty": "Aucune action pour cette date",
      "columns": {
        "order": "Commande",
        "action": "Action",
        "name": "Nom",
        "address": "Adresse",
        "suite": "Appt.",
        "timeWindows": "Créneaux",
        "phone": "Téléphone",
        "type": "Type",
        "driver": "Chauffeur"
      },
      "driverLabel": "Chauffeur",
      "allDrivers": "Tous les chauffeurs",
      "unassigned": "Non attribué",
      "overdueSince": "Échue le {date}"
    },
    "activeViews": {
      "default": "Vue par défaut",
      "driving": "Vue conduite"
    },
    "active": {
      "drive": "Conduire",
      "success": "Réussi",
      "failed": "Échoué",
      "empty": "Aucune commande active",
      "due": "À échéance",
      "callContact": "Appeler",
      "messageOnWhatsApp": "Message",
      "customerComment": "Commentaire du client",
      "moneyNotSecured": "Paiement non sécurisé",
      "confirmFutureAction": {
        "title": "Confirmer l'action",
        "message": "Cette action n'est pas due aujourd'hui. Voulez-vous vraiment continuer ?",
        "confirm": "Oui, continuer",
        "cancel": "Annuler"
      },
      "actions": {
        "customerPickup": "Collecte client",
        "customerDelivery": "Livraison client",
        "storePickup": "Collecte boutique",
        "storeDelivery": "Livraison boutique"
      }
    },
    "details": {
      "noAccess": "Cette commande ne vous est plus attribuée ; elle ne peut donc plus être ouverte ici.",
      "noAccessBack": "Retour à mes trajets"
    },
    "dispatch": {
      "title": "Affectation",
      "driverLabel": "Chauffeur affecté",
      "pickupDate": "Date de collecte réelle",
      "pickupWindow": "Créneau de collecte réel",
      "deliveryDate": "Date de livraison réelle",
      "deliveryWindow": "Créneau de livraison réel",
      "notPlanned": "Pas encore planifié",
      "assignedTo": "Affecté à {name}"
    }
  },
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "Pas de données disponibles",
    "close": "Fermer",
    "open": "Ouvert",
    "carousel": {
      "ariaLabel": {
        "delimiter": "délimiteur"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Objets par page:",
      "itemsPerPageAll": "Tout",
      "pageText": "{0}-{1} of {2}",
      "firstPage": "Première page",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante",
      "lastPage": "Dernière page"
    },
    "pagination": {
      "ariaLabel": {
        "root": "racine",
        "previous": "précédente",
        "next": "suivante",
        "currentPage": "page actuelle",
        "page": "page"
      }
    },
    "input": {
      "clear": "dégager",
      "appendAction": "ajouter une action",
      "prependAction": "préfixer l'action",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "Taille du compteur"
    },
    "rating": {
      "ariaLabel": {
        "item": "Objet"
      }
    }
  },
  "driver": {
    "myActions": {
      "title": "Mes courses",
      "dateLabel": "Date",
      "refresh": "Actualiser",
      "todaySubtitle": "Tout ce qui vous est attribué aujourd'hui, dans l'ordre réalisable.",
      "otherDaySubtitle": "Tout ce qui vous est attribué à cette date.",
      "loading": "Chargement de votre journée…",
      "empty": "Rien ne vous est attribué à cette date.",
      "emptyHint": "Les commandes apparaissent ici lorsqu'un administrateur vous les attribue depuis la page Plan."
    },
    "blocked": {
      "earlierStepPending": "Faites d'abord l'étape précédente",
      "operiClosed": "Jour non travaillé",
      "generic": "Impossible aujourd'hui"
    },
    "delivery": {
      "title": "Finaliser la livraison {order}",
      "amountToCollect": "À encaisser :",
      "tenderQuestion": "Comment le client a-t-il payé ?",
      "alreadyPaid": "Déjà payé — rien à encaisser à la porte.",
      "tender": {
        "cash": "Espèces",
        "card": "Carte au terminal",
        "notCollected": "Rien encaissé"
      },
      "overrideLabel": "Livrer sans encaisser",
      "overrideReasonLabel": "Pourquoi ?",
      "confirm": "Confirmer la livraison",
      "cancel": "Annuler",
      "failed": "Impossible de finaliser la livraison.",
      "loadFailed": "Impossible de charger les informations de paiement."
    },
    "order": {
      "loading": "Chargement de la commande…",
      "back": "Retour à mes courses",
      "customer": "Client",
      "amount": "Montant",
      "pickup": "Adresse de collecte",
      "delivery": "Adresse de livraison",
      "customerComment": "Note du client"
    },
    "overdue": "En retard de {days} j"
  },
  "availability": {
    "pickup": "Collecte",
    "delivery": "Livraison",
    "tabs": {
      "calendar": "Calendrier",
      "nonWorking": "Jours non travaillés",
      "weekly": "Fermetures hebdomadaires",
      "reasons": "Motifs"
    },
    "state": {
      "open": "Réservable",
      "beyond": "Au-delà des jours proposés",
      "closed": "Fermé",
      "windowsClosed": "Tous les créneaux fermés",
      "nonWorking": "Non travaillé",
      "past": "Passé"
    },
    "scope": {
      "OPERI": "Operi",
      "LAUNDRY": "Blanchisserie",
      "BOTH": "Les deux"
    },
    "reason": {
      "PAST": "Dans le passé",
      "WEEKLY_NON_WORKING": "Fermeture hebdomadaire",
      "NON_WORKING_DAY": "Jour non travaillé",
      "DAY_CLOSED": "Fermé par l'administrateur",
      "ALL_WINDOWS_CLOSED": "Tous les créneaux sont fermés",
      "BEYOND_HORIZON": "Au-delà des jours actuellement proposés",
      "TOO_EARLY": "Trop tôt — rien de collecté maintenant ne revient d'ici là"
    },
    "window": {
      "OPEN": "Ouvert",
      "CLOSED": "Fermé",
      "PASSED": "Passé",
      "NON_WORKING": "Non travaillé"
    },
    "drawer": {
      "bookable": "Réservable",
      "wholeDay": "Journée entière",
      "dayClosed": "Cette date est fermée aux réservations.",
      "reopenDay": "Réouvrir la journée",
      "reasonLabel": "Motif",
      "noteLabel": "Note (facultatif)",
      "closeDay": "Fermer toute la journée",
      "nothingToDecide": "Rien à fermer ici — la date est déjà indisponible.",
      "windows": "Créneaux horaires",
      "reopen": "Réouvrir",
      "close": "Fermer",
      "notClosable": "Déjà indisponible",
      "planner": "Actions de conduite",
      "opening": "Au-delà des jours proposés",
      "openDay": "Ouvrir ce jour",
      "openDayHint": "Cette date ne pose aucun problème, elle est simplement plus éloignée que les jours proposés aux clients. L'ouvrir la propose comme date de collecte supplémentaire.",
      "dayOpened": "Ouverte manuellement : les clients la voient en plus des jours habituels.",
      "removeOpening": "Ne plus la proposer"
    },
    "reasons": {
      "nameLabel": "Nouveau motif",
      "add": "Ajouter",
      "name": "Motif",
      "status": "",
      "restore": "Restaurer",
      "archive": "Archiver",
      "empty": "Aucun motif pour le moment."
    },
    "nonWorking": {
      "dateLabel": "Date",
      "scopeLabel": "Qui ne travaille pas",
      "reasonLabel": "Motif",
      "add": "Ajouter",
      "date": "Date",
      "scope": "Qui ne travaille pas",
      "reason": "Motif",
      "remove": "Supprimer",
      "empty": "Aucun jour non travaillé dans l'année à venir."
    },
    "weekly": {
      "explainer": "Fermetures permanentes, chaque semaine. Operi n'en a normalement aucune — elle roule sept jours — tandis que la blanchisserie est fermée le dimanche. Modifier ceci modifie les dates proposées aux clients.",
      "OPERI": "Operi ne roule pas",
      "LAUNDRY": "La blanchisserie ne traite pas",
      "save": "Enregistrer",
      "saved": "Enregistré"
    },
    "weekday": {
      "MONDAY": "Lun",
      "TUESDAY": "Mar",
      "WEDNESDAY": "Mer",
      "THURSDAY": "Jeu",
      "FRIDAY": "Ven",
      "SATURDAY": "Sam",
      "SUNDAY": "Dim"
    },
    "planner": {
      "loading": "Chargement du plan…",
      "empty": "Rien de planifié à cette date.",
      "customerPrefers": "Le client peut :",
      "notPlanned": "Pas encore planifié",
      "outsidePreference": "En dehors des créneaux choisis par le client",
      "storeLegs": "Échanges avec la blanchisserie (sans créneau client)",
      "operiClosed": "Personne ne conduit à cette date. Le travail a été déplacé au prochain jour ouvré.",
      "laundryClosed": "Une fermeture de la blanchisserie ajoute un jour de traitement. Les trajets vers et depuis celle-ci ne changent pas.",
      "windowLabel": "Créneau réel",
      "hiddenByFilter": "{count} masqué(s) par le filtre de chauffeur",
      "emptyForDriver": "Rien à cette date ne correspond au filtre de chauffeur.",
      "noWindowToPlan": "Aucun créneau à planifier — remise à la blanchisserie"
    },
    "dayPanel": {
      "editAvailability": "Modifier la disponibilité",
      "openWindows": "{open} créneaux ouverts sur {total}"
    },
    "calendar": {
      "windowsShort": "{open}/{total} créneaux",
      "windowsTitle": "{open} créneaux de réservation ouverts sur {total}",
      "actionsTitle": "{side} : {orders} commandes ({customer} arrêts client, {store} remises en magasin)",
      "legendLoad": "Commandes à organiser",
      "legendNonWorking": "Fermé",
      "nonWorking": {
        "OPERI": "Operi ne conduit pas",
        "LAUNDRY": "Blanchisserie fermée",
        "BOTH": "Operi et blanchisserie fermés"
      },
      "openedShort": "Ouvert",
      "legendOpened": "Ouvert manuellement",
      "openedTitle": "Ouvert manuellement, en plus des jours proposés"
    }
  }
}
